import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Button } from "baseui/button";
import { FileUploader } from "baseui/file-uploader";
import { useStyletron } from "baseui";

import { Select } from "baseui/select";

function VehicleDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const rowData = location.state?.data || {};
  const [steps, setSteps] = React.useState([]); // Initialize with an empty array

  const [css] = useStyletron();
  const apiUrl = process.env.REACT_APP_API_URL;
  const containerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    maxWidth: "1000px",
    margin: "auto",
  });

  const formStyle = css({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "20px",
    width: "100%",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
    },
  });

  console.log("rowData", rowData);

  const [formValue, setFormValue] = React.useState({
    id: rowData.id || "",
    make: rowData.make || "",
    model: rowData.model || "",
    year: rowData.year || "",
    vin: rowData.vin || "",
    stock: rowData.stock || "",
    status: rowData.status || "",
    mileage: rowData.mileage || "",
    color: rowData.color || "",
    bodytype: rowData.bodytype || "",
    engine: rowData.engine || "",
    transmission: rowData.transmission || "",
    retailprice: rowData.retailprice || "",
    requireddown: rowData.requireddown || "",
    location: rowData.location || "",
    repairfee: rowData.repairfee || "",
    // additional fields as needed
  });

  const [dataOne, setDataOne] = React.useState(null);
  const [imageFile, setImageFile] = React.useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(null);
  const [uploadError, setUploadError] = React.useState(null);

  console.log("formValue", formValue); // passed in from the state argument from /vehicleList

  React.useEffect(() => {
    if (formValue.vin) {
      const fetchVehicleDetails = async () => {
        try {
          const response = await axios.post(`${apiUrl}/api/vehicle/dataone`, {
            vin: formValue.vin,
          });
          if (response.status === 200) {
            const dataOne = response.data.vin_details;
            setDataOne(dataOne);
            console.log("DataOne:", dataOne);
          }
        } catch (error) {
          console.error("Error fetching vehicle details:", error);
          alert(`Error fetching vehicle details: ${error.message}`);
        }
      };

      const fetchSteps = async () => {
        try {
          const response = await axios.get(`${apiUrl}/api/steps`);
          if (response.status === 200) {
            // Process the response data
            setSteps(response.data.steps);
            // console.log("Data fetched successfully:", response.data.steps);
            // You can update your state or do other things with response.data here
          } else {
            console.error("Unexpected response status:", response.status);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          // Optionally handle the error, show an alert, etc.
        }
      };

      // const fetchSteps = async () => {
      //   try {
      //     const response = await axios.get(`${apiUrl}/api/steps`);
      //     if (response.status === 200) {
      //       // Assuming response.data.steps is an array of objects
      //       const stepNames = response.data.steps.map((step) => step.step_name); // Map over to extract step_name
      //       setSteps(response.status.data); // Set steps as an array of strings
      //       console.log("Step names fetched successfully:", stepNames);
      //     } else {
      //       console.error("Unexpected response status:", response.status);
      //     }
      //   } catch (error) {
      //     console.error("Error fetching data:", error);
      //     // Optionally handle the error, show an alert, etc.
      //   }
      // };

      fetchVehicleDetails();
      fetchSteps();
    }
  }, [formValue.vin, apiUrl]);

  console.log("steps", steps);

  const handleInputChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const handleFileChange = (acceptedFiles, rejectedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setImageFile(file);
      const url = URL.createObjectURL(file);
      setImagePreviewUrl(url);
      setUploadError(null); // Clear error on successful upload
    } else if (rejectedFiles && rejectedFiles.length > 0) {
      // Handle the rejection case
      setUploadError("File not accepted"); // Set an appropriate error message
    }
  };

  //ifetch 'steps' into a useState instead of using 'statusOptions' array here,

  // /api/inspections

  const handleSubmit = async () => {
    const formData = new FormData();
    Object.keys(formValue).forEach((key) =>
      formData.append(key, formValue[key])
    );

    if (imageFile) {
      formData.append("imageFile", imageFile);
    }

    try {
      const response = await axios.post(
        `${apiUrl}/api/vehicle/update`,
        formData
      );
      if (response.status === 200) {
        alert("Vehicle added successfully");
        setFormValue({
          make: "",
          model: "",
          year: "",
          vin: "",
          stock: "",
          status: "",
          mileage: "",
          color: "",
          bodytype: "",
          engine: "",
          transmission: "",
          retailprice: "",
          requireddown: "",
          location: "",
          repairfee: "",
          // Reset additional fields as needed
        });
        setImageFile(null); // Reset file input
        setImagePreviewUrl(null); // Reset image preview
      } else {
        alert("Failed to add vehicle");
      }
    } catch (error) {
      console.error("Error adding vehicle:", error);
      alert(`Error while adding vehicle: ${error.message}`);
    }
  };

  const handleOpenSticker = () => {
    if (dataOne) {
      navigate("/window-sticker", { state: { formValue, dataOne } });
    } else {
      alert("DataOne details are not yet loaded.");
    }
  };

  React.useEffect(() => {
    // Cleanup function to revoke the object URL
    return () => {
      if (imagePreviewUrl) {
        URL.revokeObjectURL(imagePreviewUrl);
      }
    };
  }, [imagePreviewUrl]);

  return (
    <div className={containerStyle}>
      <h1>Vehicle Details</h1>
      <div className={formStyle}>
        <div>
          <FormControl label="*VIN">
            <Input
              name="vin"
              onChange={handleInputChange}
              value={formValue.vin}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Make">
            <Input
              name="make"
              onChange={handleInputChange}
              value={formValue.make}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Model">
            <Input
              name="model"
              onChange={handleInputChange}
              value={formValue.model}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Year">
            <Input
              name="year"
              onChange={handleInputChange}
              value={formValue.year}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Color">
            <Input
              name="color"
              onChange={handleInputChange}
              value={formValue.color}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Odometer">
            <Input
              name="mileage"
              type="number"
              onChange={handleInputChange}
              value={formValue.mileage}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Stock Number">
            <Input
              name="stock"
              onChange={handleInputChange}
              value={formValue.stock}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Purchase Price">
            <Input
              name="retailprice"
              onChange={handleInputChange}
              min="0.00"
              step="0.01"
              value={formValue.retailprice}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Required Down">
            <Input
              name="requireddown"
              onChange={handleInputChange}
              value={formValue.requireddown}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Body Type">
            <Input
              name="bodytype"
              onChange={handleInputChange}
              value={formValue.bodytype}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Engine">
            <Input
              name="engine"
              onChange={handleInputChange}
              value={formValue.engine}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Transmission">
            <Input
              name="transmission"
              onChange={handleInputChange}
              value={formValue.transmission}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Location">
            <Input
              name="location"
              onChange={handleInputChange}
              value={formValue.location}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="*Repair Fee">
            <Input
              name="repairfee"
              onChange={handleInputChange}
              value={formValue.repairfee}
              required
              disabled
            />
          </FormControl>
        </div>
        <div>
          <FormControl label="Status">
            <Select
              // options={steps}
              options={steps.map((step) => ({
                id: step.id,
                label: step.step_name,
              }))}
              // value={
              //   formValue.status
              //     ? [steps.find((opt) => opt.id === formValue.status)]
              //     : []
              // }
              // onChange={(params) =>
              //   setFormValue({
              //     ...formValue,
              //     status: params.value[0]?.id || "",
              //   })
              // }
              // placeholder="Select Vehicle's Status"
              // required
              // disabled
              value={
                formValue.status
                  ? steps
                      .filter((step) => step.id === formValue.status)
                      .map((step) => ({ id: step.id, label: step.step_name }))
                  : []
              }
              onChange={(params) =>
                setFormValue({
                  ...formValue,
                  status: params.value[0]?.id || "", // Assign the selected id to formValue.status
                })
              }
              placeholder="Select Vehicle's Status"
              required
              disabled={steps.length === 0}
            />
          </FormControl>
        </div>
      </div>

      {/***********************************  ***********************************/}
      <div className="w-100">
        <FormControl label="*Vehicle Image">
          <div>
            <FileUploader
              onDrop={handleFileChange}
              accept="image/*"
              errorMessage={uploadError}
              required
              disabled
            />
            {imagePreviewUrl && (
              <img
                src={imagePreviewUrl}
                alt="Preview"
                style={{ width: "100%", marginTop: "10px" }}
              />
            )}
          </div>
        </FormControl>
      </div>
      <Button className="w-100" onClick={handleSubmit}>
        Update Vehicle
      </Button>
      <Button
        className="w-100"
        onClick={handleOpenSticker}
        style={{ marginTop: "20px" }}
      >
        Print Window Sticker
      </Button>
    </div>
  );
}

export default VehicleDetails;
